<section class="footer-leave-dialog hdmui-background-2">
    <div class="footer-leave-dialog__action-buttons">
        <button
            mat-stroked-button
            (click)="onButtonClick(SIGN_OFF_WORKSTATION)"
            data-testid="footer-leave-dialog-sign-off-workstation"
        >
            <span> {{ 'DC.LEAVE_DIALOG.SIGN_OFF_WORKSTATION' | translate }}</span>
        </button>
        <button mat-stroked-button (click)="onButtonClick(END_SHIFT)" data-testid="footer-leave-dialog-end-shift">
            <span> {{ 'DC.LEAVE_DIALOG.END_SHIFT' | translate }}</span>
        </button>
        <button
            class="button__last"
            mat-stroked-button
            (click)="onButtonClick(MANAGE_ASSISTANTS)"
            data-testid="footer-leave-dialog-manage-assistants"
        >
            <span> {{ 'DC.LEAVE_DIALOG.MANAGE_ASSISTANTS' | translate }}</span>
        </button>
        <button class="button__last" mat-button (click)="onButtonClick(false)" data-testid="footer-leave-dialog-cancel">
            <span> {{ 'DC.LEAVE_DIALOG.CANCEL' | translate }}</span>
        </button>
    </div>
</section>
